
import {
    ApplicationUserModel,
    AuditModel,
    AuditTimingTypeEnum,
    PlanItemModel,
    PermissionTypeEnum,
    TenantUserModel,
    ProcessTypeEnum,
} from '@/libs/Api';
import Page from '@/Page.vue';
import { Guid } from '@/libs/common/functions/guid';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { planItemsStore } from '@/libs/plan-items/+state/store';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import moment from 'moment';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import ShiftTypeSelect from '@/libs/common/components-smart/ShiftTypeSelect.vue';
import { auditsStore } from '@/libs/audits/+state/store';
import CustomerSelect from '@/libs/common/components-smart/CustomerSelect.vue';

@Component({
    components: { CustomerSelect, ShiftTypeSelect },
})
export default class WorkTaskCreateDialog extends Page {
    dialog = false;
    valid = true;
    saving = false;
    isPeriod = false;
    item: PlanItemModel | null = null;
    applicationUser: ApplicationUserModel = applicationUserStore.useGetter(CrudGetter.Detail) as ApplicationUserModel;
    tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
    audit: AuditModel | null = null;
    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    PermissionTypeEnum: typeof PermissionTypeEnum = PermissionTypeEnum;

    @Prop({ default: false }) activator!: boolean;
    @Prop({ default: false }) mobile!: boolean;

    @Watch('dialog')
    dialogChanged(v: boolean) {
        if (!v) this.close();
    }

    @Ref() form!: any;
    @Prop() tenantId!: string;
    @Prop() auditId!: string;

    // ✅ NOVÝ SYSTÉM: Kontroluje, zda může uživatel vytvořit work task (plánovat audit)
    get canCreateWorkTask(): boolean {
        // Pokud má přístup ke všem kategoriím, zkontroluj globální oprávnění
        if (this.tenantUser.accessAllCategories) {
            const permissions = authStore.useGetter(AuthGetter.GetPermissions) as PermissionTypeEnum[];
            return permissions.contains(PermissionTypeEnum.AuditSchedule);
        }

        // Pokud nemá přístup ke všem, zkontroluj, zda má alespoň jednu kategorii s těmito oprávněními
        const accessible = this.getUserAccessibleCategoryIds([
            PermissionTypeEnum.AuditSchedule
        ]);
        return accessible.length > 0;
    }

    open() {
        this.$nextTick(() => {
            if (this.auditId) {
                auditsStore.dispatch(CrudAction.Get, { id: this.auditId });
                this.subscribe(auditsStore, CrudReponse.Get).then((e: AuditModel) => {
                    this.audit = e;
                    this.dialog = true;
                    this.isPeriod = false;
                    this.item = {
                        id: Guid.EmptyGuid(),
                        auditId: this.auditId,
                        audit: e,
                        tenantUserId: this.tenantUser.id,
                        time: moment().add(1, 'day').format('YYYY-MM-DDT08:00:00'),
                        workplaceId: null,
                        processType: e.processType,
                        auditTimingType: AuditTimingTypeEnum.ByUser,
                        auditTenantUsers: [
                            {
                                tenantUserId: this.tenantUser.id,
                            },
                        ],
                    } as PlanItemModel;
                });
            } else {
                this.dialog = true;
                this.isPeriod = false;
                this.item = {
                    id: Guid.EmptyGuid(),
                    auditId: undefined,
                    audit: undefined,
                    tenantUserId: this.tenantUser.id,
                    time: moment().add(1, 'day').format('YYYY-MM-DDT08:00:00'),
                    workplaceId: null,
                    auditTimingType: AuditTimingTypeEnum.ByUser,
                    auditTenantUsers: [
                        {
                            tenantUserId: this.tenantUser.id,
                        },
                    ],
                } as PlanItemModel;
            }
        });
    }

    onAuditChange(auditId: string) {
        auditsStore.dispatch(CrudAction.Get, { id: auditId });
        this.subscribe(auditsStore, CrudReponse.Get).then((e: AuditModel) => {
            this.audit = e;
            this.item!.auditId = auditId;
            this.item!.audit = e;
            this.item!.processType = e.processType;
        });
    }

    close() {
        this.dialog = false;
        this.audit = null;
    }

    save() {
        if (this.form.validate()) {
            this.saving = true;
            const item = { ...this.item } as PlanItemModel;
            item.auditTenantUsers = [
                {
                    tenantUserId: item.tenantUserId!,
                },
            ];
            const time = moment(item.time).format('YYYY-MM-DDT08:00:00');
            item.since = time;
            if (!this.isPeriod) {
                item.until = time;
            }
            planItemsStore.dispatch(CrudAction.Create, { item: item });
            this.subscribe(planItemsStore, CrudReponse.Create)
                .then((e: PlanItemModel) => {
                    this.saving = false;
                    this.close();
                    this.$emit('created', e);
                })
                .catch((e: any) => {
                    this.saving = false;
                });
        }
    }
}
